export default __webpack_public_path__ + "static/media/RegistrationConfirmation.d70f0a04.png";